import { Paper, Tab, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import NestedRouteLayout from 'core/layout-core/NestedRouteLayout';
import { FileDataContext, FileDataContextInterface } from 'hooks/FileDataContext';
import { ProfileContext, ProfileContextInterface } from 'hooks/ProfileContext';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BottomAppBar from 'ui-kit/components/bottomAppBar/BottomAppBar';
import { UserRoleTypes } from './constants';

type getFileInfoProps = {
  fileId?: string;
  tabId?: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minHeight: 'calc(100vh - 64px)',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 64,
    },
    tabWrap: {
      padding: `0 ${theme.spacing(2)}px`,
      borderBottom: `1px solid #e5e5e5`,
    },
    tabMargin: {},
  }),
);

const AdminUserProfileContainer = ({ routes }: any): JSX.Element => {
  const classes = useStyles();
  const [footer] = useState(false);
  const { tabId } = useParams<getFileInfoProps>();
  const history = useHistory();
  const fileDataCtx: FileDataContextInterface = useContext(FileDataContext) ?? {};
  const { tabValue, setTabValue } = fileDataCtx;

  const profileCtx: ProfileContextInterface = useContext(ProfileContext) ?? {};

  useEffect(() => {
    if (tabId) {
      tabId === 'backtitle' && setTabValue && setTabValue('1');
      tabId === 'cpl' && setTabValue && setTabValue('2');
      tabId === 'service-orders' && setTabValue && setTabValue('3');
      tabId === 'underwriting' && setTabValue && setTabValue('4');
      tabId === 'jackets' && setTabValue && setTabValue('5');
      tabId === undefined && setTabValue && setTabValue('0');
    }
  }, [tabId]);

  useEffect(() => {
    const activeTab = localStorage.getItem('activeTab');

    if (history.location.pathname === '/admin/user/profile/updateAuthentication/Cancel')
      history.push(`/admin/user/profile`);
    if (activeTab === null || activeTab === 'UserProfileTab') {
      setTabValue && setTabValue('0');
    } else {
      setTabValue && setTabValue('1');
    }
  }, []);

  const onTabChange = (v: any) => {
    if (setTabValue) {
      setTabValue(v);
    }
    if (v === 0) {
      history.push(`/admin/user/profile`);
      localStorage.setItem('activeTab', 'UserProfileTab');
    }
    if (v === 1) {
      history.push(`/admin/user/preferred-offices`);
      localStorage.setItem('activeTab', 'PreferredOfficesTab');
    }
  };

  const TabNavigation = (): JSX.Element => {
    return (
      <Paper square elevation={0} className={classes.tabWrap}>
        <Tabs
          value={parseInt(tabValue || '0')}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, v) => onTabChange(v)}
        >
          <Tab data-testid="UserProfileTab" label="Profile" onClick={() => history.push(`/admin/user/profile`)} />
          {profileCtx.profile?.roleTypeId === UserRoleTypes.Staff ? null : (
            <Tab
              //disabled={!isEnableAllFeatures()}
              data-testid="PreferredOfficesTab"
              label="Preferred Offices"
              onClick={() => history.push(`/admin/user/preferred-offices`)}
            />
          )}
        </Tabs>
      </Paper>
    );
  };

  return (
    <div className={classes.root}>
      {routes?.length > 0 ? (
        <>
          <TabNavigation />
          <NestedRouteLayout {...{ routes }} />
        </>
      ) : (
        <>
          <div className={classes.tabMargin}></div>
          {footer && <BottomAppBar primaryActionLabel="Search" secondaryActionLabel="Clear All" />}
        </>
      )}
    </div>
  );
};

export default AdminUserProfileContainer;
